<template>
    <section class="ad-content-card">
        <div class="ad-content-card-container">
            <img :src="imageSrc" alt="" class="ad-content-card-img"/>
            <div class="ad-content-card-txt">
                    <h2>{{ title }}</h2>
                    <p>{{ text }}</p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "AdContentCard",
    props: {
        imageSrc: {
          type: String,
          required: true
        },
        title: {
          type: String,
          required: true
        },
        text: {
          type: String,
          required: true
        },
      },
    setup() {


        return {

        }

    }
};
</script>

<style scoped>
.ad-content-card {
    background: linear-gradient(rgba(255, 171, 184, 0) 0%, rgba(248, 187, 208, 0.29)  50%, rgba(251, 179, 196, 0) 100%);
}

.ad-content-card-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-inline: 32.5%;
}

.ad-content-card-img {
    aspect-ratio: 374 / 356;
    width: 78%;
    max-width: 374px;
    max-height: 356px;
    object-fit: contain;
}

.ad-content-card-txt {
    animation: fadeIn 3s ease-out forwards;
}

.ad-content-card-txt h2 {
    font-family: 'IRANYekan-Bold';
    font-size: 28px;
    line-height: 38px;
    margin-bottom: 4.97%;
}

.ad-content-card-txt h2,
.ad-content-card-txt p {
    text-align: justify;
}

.ad-content-card-txt p {
    line-height: 28px;
}

@media screen and (min-width: 1441px) {
    .ad-content-card-container {
        width: 484px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1024px) {
    .ad-content-card {
        background: unset;
    }

    .ad-content-card-container {
        margin-inline: 28.2%;
    }

    .ad-content-card-txt h2 {
        font-size: 24px;
        line-height: 28px;
    }

     .ad-content-card-txt p {
        line-height: 26px;
     }
}

@media screen and (max-width: 768px) {
    .ad-content-card-container {
        margin-inline: 9.03%;
    }

    .ad-content-card-img {
        width: 273px;
        height: 273px;
    }

    .ad-content-card-txt h2 {
        margin-bottom: 16px;
    }
}

@media screen and (max-width: 375px) {
    .ad-content-card-txt h2 {
        font-size: 20px;
        margin-bottom: 16px;
    }

    .ad-content-card-txt p {
        font-size: 16px;
    }
}
</style>